import { render, staticRenderFns } from "./MonthlyOrdersGraph.vue?vue&type=template&id=4ee6669c&scoped=true"
import script from "./MonthlyOrdersGraph.vue?vue&type=script&lang=ts"
export * from "./MonthlyOrdersGraph.vue?vue&type=script&lang=ts"
import style0 from "./MonthlyOrdersGraph.vue?vue&type=style&index=0&id=4ee6669c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ee6669c",
  null
  
)

export default component.exports